export const notificationsSelector = (state: RootState) => state.snackbar.notifications;
